<script setup lang="ts">
defineOptions({ inheritAttrs: false });
</script>
<template>
  <nut-rate v-bind="$attrs" />
</template>
